import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { CanActivate, Router } from '@angular/router';
import { switchMap, take } from 'rxjs';
import { IdbService } from '../services/idb/idb.service';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate {
  constructor(
    private afAuth: AngularFireAuth,
    private router: Router,
    private idb: IdbService
  ) {}

  canActivate() {
    return this.afAuth.authState.pipe(
      take(1),
      switchMap(async (authState) => {
        if (!authState) {
          this.router.navigate(['/auth']);
          return false;
        }
        this.idb.getUserRole(authState.uid).subscribe((role) => {
          if (role !== 'Admin' && role !== 'Super Admin') {
            this.router.navigate(['/auth']);
            return false;
          } else {
            return true;
          }
        });
        return true;
      })
    );
  }

  // canActivate1() {
  //   console.log('hit?');
  //   return this.afAuth.authState.pipe(
  //     take(1),
  //     switchMap(async (authState) => {
  //       if (!authState) {
  //         this.router.navigate(['/auth']);
  //         return false;
  //       }
  //       const token = await authState.getIdTokenResult();
  //       if (!token.claims?.['admin']) {
  //         this.router.navigate(['/auth']);
  //         return false;
  //       }
  //       return true;
  //     })
  //   );
  // }
}
